import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const DynamicChannelRBAC = {
  pageID: '6b71751eb5012613ca438318d810454d',
  elementID: {
    ViewList: 'e9d4ad7a4e18207f7b9717d8a941b783',
    CreateDynamicChannel: '9c7fea61abc27092bca1190bc4933ba5',
    EditDynamicChannel: 'bb6d0c05e8d4bd1d08fc3d9483a14541',
    DeleteDynamicChannel: '9b4d319273feea82158e283bb1df8614',
    ToggleStatusDynamicChannel: '7186e1369d2c429720cbcc0bcd920d13',
  },
} as const

export const useRBACDynamicChannelPage = createUseRBAC(DynamicChannelRBAC.elementID)

export type UseRBACDynamicChannelPageType = ReturnType<typeof useRBACDynamicChannelPage>
